import {catchError, EMPTY, filter, Observable, switchMap, take, tap} from 'rxjs';
import {Store} from '@ngxs/store';
import {LoadGlobalPageElementBySlug} from '@store/global-page-element/global-page-element.actions';
import {
  UmpireComponentBranding,
  UmpireComponentBrandingThemeEnum,
  UmpireComponentTypeEnum,
  UmpireGlobalPageElementSlugEnum,
} from '@tisa-group/models';
import {GlobalPageElementState} from '@store/global-page-element/global-page-element-state.service';
import {Injector} from '@angular/core';
import {WINDOW} from '@ng-web-apis/common';
import {CurrentClientState} from '@store/current-client/current-client.state';
import {ImageVariantPipe} from '@tisa-group/core';

export function globalBrandingInitializerFactory(
  store: Store,
  injector: Injector,
): () => Observable<unknown> {
  return () => {
    const window = injector.get(WINDOW);

    return store
      .dispatch(
        new LoadGlobalPageElementBySlug(UmpireGlobalPageElementSlugEnum.BRANDING, {
          include: 'components,components.logo,components.favicon,components.meta_image',
        }),
      )
      .pipe(
        catchError(error => EMPTY),
        switchMap(() =>
          store.select(
            GlobalPageElementState.getGlobalPageElementBySlug(
              UmpireGlobalPageElementSlugEnum.BRANDING,
            ),
          ),
        ),
        filter(Boolean),
        take(1),
        tap(data => {
          const branding = data?.components?.find(
            item => item.kind === UmpireComponentTypeEnum.BRANDING,
          ) as UmpireComponentBranding;

          if (!branding) {
            return;
          }
          // set theme and accent

          const root = window.document.querySelector<HTMLElement>(':root');

          if (!root?.classList?.length) {
            const themes = [
              UmpireComponentBrandingThemeEnum.black,
              UmpireComponentBrandingThemeEnum.gray,
            ];

            if (themes.includes(branding.theme)) {
              themes.forEach(availableTheme =>
                window.document.querySelector(':root')?.classList.remove(availableTheme),
              );

              if (branding.theme) {
                root?.classList.add(branding.theme);
              } else {
                root?.classList.add('ThemeGrey-Smart');
              }
            }

            root?.style.setProperty('--umpire-theme-accent', branding.theme_accent);
          }

          // set favicon
          if (branding.favicon) {
            // CurrentClientInitializer is run concurrently, we have to wait to set the favicon until we have cloudfront_id
            store
              .select(CurrentClientState.getData)
              .pipe(filter(Boolean), take(1))
              .subscribe(clientData => {
                let link =
                  window.document.querySelector<HTMLLinkElement>("link[rel~='icon']");

                if (!link) {
                  link = document.createElement('link');
                  link.rel = 'icon';
                  document.head.appendChild(link);
                }
                const imageVariantPipe = new ImageVariantPipe(
                  clientData.config.external_dependencies.cloudfront_id,
                  null,
                );

                link.href = imageVariantPipe.transform(branding.favicon || undefined, {
                  width: 32,
                  height: 32,
                  quality: 70,
                });
              });
          }
        }),
      );
  };
}
